import { Component, OnInit, NgZone, OnDestroy, ViewChild } from '@angular/core';
import { StringFilter } from "clarity-angular";
import { Location } from '@angular/common';
import { Router,ActivatedRoute, Params } from '@angular/router';
import { AlertService } from '../services/alert.service';
import { LimitsService } from '../limits/limits.service';
import { ReportsService } from '../reports/reports.service';
import { Subscription } from 'rxjs/Subscription';
import { ConfigMaxSetAttributes } from '../models/configmaxsetattributes';
import { HeaderData } from '../models/headerdata ';
import { ElementData } from '../models/elementdata';
import { ConfigMaxSet } from '../models/configmaxset';
import { ConfigMaxSetAttrAuthors } from '../models/configmaxsetattrauthors';
import { AuthorTypes } from '../common/data/authortypes';
import { AuthService } from '../auth/authservice.service';
import { CategoryDataRecord } from '../models/categorydatarecord';
import { CategoriesRecord } from '../models/categoriesrecord';
import { LimitsConstant } from "./limitsconstant";
import { CategoryModalComponent } from "./categorymodal/categorymodal.component";
import { MaximumCategory } from 'app/models/maximumcategory';
import { NumberConstants } from "../common/numberconstants";
import { Globals } from 'app/common/globals';
import { TranslateService } from '@ngx-translate/core';
import { EnvironmentsService } from 'app/services/enviornment.service';

class ItemFilter implements StringFilter<string> {
    accepts(maximum: any, search: string): boolean {
        return maximum.headername.toLowerCase().indexOf(search) >= 0;
    }
}

@Component({
    styleUrls: ['./limits.component.scss'],
    templateUrl: './limits.component.html',
    providers: [LimitsConstant]
})
export class LimitsComponent implements OnInit, OnDestroy {
    private selectedConfigStatusId: number;
    private configSetId: number;
    private subscription: Subscription;
    private itemFilter = new ItemFilter();
    title: string = "";
    conListLabel: String;
    addOpen: boolean = false;
    editOpen: boolean = false;
    createProjectOpen: boolean = false;
    typeOfCreation: string = "";
    newCreationData: any = [];
    maximumids: number[] = new Array();
    maximumSubids: number[] = new Array();
    maximumsCats: any[] = new Array();
    maximumsRight: any;
    selectedMaximum: any;
    selectedAssignedMax: any;
    dataHeaders: any;
    copyversions: any;
    user: any;
    langSub: Subscription;
    headerName: any;
    arr: any = [];
    modalProps = {
        state: false,
        backdrop: true,
        closable: false,
        title: "Delete Configuration",
        bodyContent: "Are you Sure ?",
        cancelButton: "Cancel",
        okButton: "Delete",
        cancelBClass: "btn-outline",
        okBClass: "btn-danger",
        hidden: false
    };
    chatModalProps: any;
    assignTeamMemberData = {
        state: false,
        backdrop: true,
        title: this.translateService.instant('manLimits.commentColumnDataGrid'),
        cancelButton: this.translateService.instant('cancel'),
        okButton: this.translateService.instant('assign'),
        cancelBClass: "btn-outline",
        okBClass: "btn-primary",
        size: 'md',
        elements: [
            {
                type: "text",
                label: this.translateService.instant('manLimits.commentColumnEmail'),
                size: this.numberConstant.FORTYFIVE,
                placeHolder: this.translateService.instant('teamEmail'),
                selectedValue: ""
            }
        ]
    };
    importConfigData = {
        state: false,
        backdrop: true,
        title: "Import Configuration",
        subTitle: "Select a xsl/csv file to upload",
        cancelButton: "Cancel",
        okButton: "Upload",
        cancelBClass: "btn-outline",
        okBClass: "btn-primary",
        size: 'md',
        elements: [
            {
                type: "file"
            }
        ]
    };
    addConfigData: any;
    updateProjectData: any;
    createMaximumData: any;
    maximums: any = null;
    loaded = true;
    selectedConfigId;
    selectedAuthor: String;
    approvedStatus: number = this.numberConstant.APPROVEDSTATUS;
    approvals: any
    selectedConfigName;
    headerslist: any;
    keylist: any;
    selectedAttribute: any;
    currentUser = JSON.parse(localStorage.getItem('currentUser'));
    // pagination
    p: number = this.numberConstant.ONE;
    totalRec: number = this.numberConstant.ZERO;
    itemsPerPage =this.numberConstant.SIX;
    page = this.numberConstant.ONE;
    selectedRowMaximum: any;
    currentVersionData: any;
    prodMgr: ElementData;
    prodData: ElementData;
    currentMaximumData: ElementData;
    maximum_edited: any;
    @ViewChild(CategoryModalComponent) categorymodal: CategoryModalComponent;
    selectedBtnId: string = "deleteBtn";

    constructor(private zone: NgZone, private alertService: AlertService,
        private limitsService: LimitsService,
        private reportservice: ReportsService,
        private authservice: AuthService,private globals: Globals, private translateService: TranslateService, private envService: EnvironmentsService,
        private limitsconstant: LimitsConstant,private location: Location,private route: ActivatedRoute,private numberConstant:NumberConstants) {
        if (this.maximums == null || (this.maximums != null && this.maximums.length == this.numberConstant.ZERO)) {
            this.typeOfCreation = "config";
        }
        // this.initializeConfiguration();
        // this.initializeHeaders();
        this.initializeproductData("", [], false);
        this.initializeChatModal([]);
        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        this.user = currentUser? currentUser.userName: null;
           }

    getSelProductVersions(prodId, isprod, urlIndex): void {
        this.reportservice.getProductVersions(prodId, urlIndex)
            .subscribe(vmwareproductsVersions => {
                let arr: any = new Array();
                vmwareproductsVersions.forEach(element => {
                    arr.push({
                        id: element.id, value: element.rmVmwPrdRelVersion
                    });
                    this.copyversions = arr;
                    this.setConfigdata(this.title, this.reportservice.selectedprodID,
                        this.reportservice.selectedversionID, true);
                });
            },
                err => {
                    console.log(err)
                    this.alertService.warn(this.title + this.limitsconstant.editConfigMaxSetAlertLabel);
                    window.setTimeout(() => this.alertService.clear(), this.numberConstant.ALERT_DELAY_3000);
                });

    }
    ngOnInit() {
        this.langSub = this.envService.selectedLanguage$.subscribe((lang)=>{
            this.initializeConfiguration();
            this.initializeHeaders();
            this.dataHeaders[0].headerName = this.translateService.instant('manLimits.dataGridLabels');
            this.dataHeaders[1].attrName = new HeaderData(this.translateService.instant('item'), "", "", false);
            this.dataHeaders[2].testplan = new HeaderData(this.translateService.instant('manLimits.testLimit'), "", "", false);
            this.dataHeaders[3].pmt = new HeaderData(this.translateService.instant('manLimits.jiraPmt'), "", "", true);
            this.dataHeaders[4].isinternal = new HeaderData(this.translateService.instant('review.keepInternal'), "", "", false);
            this.dataHeaders[5].target = new HeaderData(this.translateService.instant('manLimits.targetLimit'), "", "", false);
            this.dataHeaders[6].publish = new HeaderData(this.translateService.instant('manLimits.publishLimit'), "", "", false);
            this.dataHeaders[7].comment = new HeaderData(this.translateService.instant('limit.comment'), "", "", false);
            this.addConfigData.title = this.translateService.instant('addMaximumTitle');  
            this.arr[0].header = this.translateService.instant('label');
            this.arr[1].headernew = this.translateService.instant('newLabel');
            this.arr[2].attrName = this.translateService.instant('item');
            this.arr[4].performanceMember = ElementData.getVersiondata(this.translateService.instant('manLimits.performanceMember'));
            this.arr[5].qeMember = ElementData.getVersiondata(this.translateService.instant('manLimits.qeMember'));
            this.arr[6].productManager = ElementData.getVersiondata(this.translateService.instant('manLimits.prodManager'));
            this.arr[7].devMember = ElementData.getVersiondata(this.translateService.instant('manLimits.devMember'));
            this.arr[8].targetValue= ElementData.getattrdata(this.translateService.instant('manLimits.targetLimit'));
            this.arr[9].publishvalue = ElementData.getattrdata(this.translateService.instant('manLimits.publishLimit'));
            this.arr[10].testPlan = ElementData.getVersiondata(this.translateService.instant('manLimits.testLimit'));
            this.arr[11].pmt = ElementData.getVersiondata(this.translateService.instant('manLimits.jiraPmt'));
            this.arr[12].isInternal = this.translateService.instant('review.keepInternal');
            this.arr[13].desc = this.translateService.instant('viewLimits.description');
            this.chatModalProps.commentPlaceHolder = this.translateService.instant('revPubl.dataGridComment');
            this.conListLabel = this.translateService.instant('configTitle')
            this.modalProps.title = this.translateService.instant('limit.delete') + this.selectedConfigName;
            this.modalProps.cancelButton = this.translateService.instant('cancel');
            this.modalProps.title = this.translateService.instant('limit.delete') + this.selectedConfigName;
            this.modalProps.bodyContent = this.translateService.instant('delMessage');
            this.modalProps.okButton = this.translateService.instant('limit.delete');
            this.modalProps.title = this.translateService.instant('limit.approve') + this.selectedConfigName;
            this.modalProps.bodyContent = this.translateService.instant('admin.EnableRelMsg');
            this.modalProps.bodyContent = this.translateService.instant('categoryDelWarningMsg');
            this.modalProps.bodyContent = this.translateService.instant('categoryDelMsg');
            this.modalProps.bodyContent = this.translateService.instant('WarningMsg_IfSubcategoryExists');
            this.modalProps.okButton = this.translateService.instant('limit.delete');
            this.modalProps.title + this.translateService.instant('noChnagesAlertLabel');
            this.addConfigData.title = this.addConfigData.title + this.translateService.instant('editSubtitle');
            this.addConfigData.okButton = this.translateService.instant('save');
            this.addConfigData.title = this.translateService.instant('addMaximumTitle');
            this.addConfigData.okButton = this.translateService.instant('addString');
            this.arr[0].value = this.translateService.instant('selectHeaderLabel');
            let title = this.translateService.instant('configAlertLabel') + this.addConfigData.subTitle;
            this.addConfigData.okButton === this.translateService.instant('save');
            title = this.translateService.instant('configAlertLabel') + this.addConfigData.subTitle;
            this.assignTeamMemberData.elements[0].placeHolder = this.translateService.instant('teamEmail');
            this.assignTeamMemberData.title = this.translateService.instant('manLimits.commentColumnDataGrid');
            this.assignTeamMemberData.cancelButton = this.translateService.instant('cancel');
            this.assignTeamMemberData.okButton = this.translateService.instant('assign');
            this.assignTeamMemberData.elements[0].label = this.translateService.instant('manLimits.commentColumnEmail');
        });
        this.subscription = this.route.queryParams.subscribe((params: Params) => {
            if (params['vmwareproduct']) {
            this.reportservice.selectedBookmarkedprod = params["vmwareproduct"];
            this.reportservice.selectedBookmarkedversion = params["release"];
            this.reportservice.selectedBookmarkedCategories = params["categories"];
            } else {
                let bookmark :String = localStorage.getItem('bookmark');
                if(bookmark != undefined && bookmark.length >this.numberConstant.ZERO) {
                    let bookmarkArray :any = bookmark.split("?");
                    this.reportservice.setBookMarkedSearch(bookmarkArray[this.numberConstant.ONE]);
                    localStorage.setItem('bookmark',"");   
                }
            }
            
        });
        this.reportservice.categoriesArray = [];                                                                                
        this.totalRec =this.numberConstant.ZERO;
        this.subscription = this.reportservice.notifyObservable$.subscribe((res) => {
            if (res.hasOwnProperty('option') && res.option === 'click') {
                // perform your other action from here
                this.maximumids = this.reportservice.maximumsCats1Selected;
                this.maximumSubids = this.reportservice.maximumsSubCats1Selected;
                this.page = this.numberConstant.ONE;
                this.p = this.numberConstant.ONE;
                this.totalRec = this.numberConstant.ZERO;
                this.maximums = [];
                this.loaded = false;
                this.getTotalDataCount(this.reportservice.selectedprodID, this.reportservice.selectedversionID);
                this.getdata(this.reportservice.selectedprodID, this.reportservice.selectedversionID);
                this.reportservice.onBookMark("/reports/limits",false,false,true);                                
            } else if (res.hasOwnProperty('option') && res.option === 'title') {
                this.title = res.value;
                this.maximumids = [];
                this.maximumSubids = [];
                this.page =  this.numberConstant.ONE;
                this.p =  this.numberConstant.ONE;
                this.totalRec =  this.numberConstant.ZERO;
                this.maximums = [];
                this.reportservice.onBookMark("/reports/limits",false,false,true);                                                
            }
            if (this.reportservice.selectedBookmarkedCategories != null &&
                this.reportservice.selectedBookmarkedCategories != undefined &&
                this.reportservice.selectedBookmarkedCategories.length >  this.numberConstant.ZERO) {
                    let queryString = "reports/limits?vmwareproduct=" + this.reportservice.selectedBookmarkedprod + 
                    "&release=" + this.reportservice.selectedBookmarkedversion + "&categories=" + this.reportservice.selectedBookmarkedCategories;
                this.reportservice.setSelectedCategories(queryString,this.reportservice.selectedCategories,);
                if( this.reportservice.categoriesArray.length > this.numberConstant.SIX) {
                    this.getTotalDataCount(this.reportservice.selectedprodID, this.reportservice.selectedversionID);
                   }
                   this.loaded = false;
            this.getdata(this.reportservice.selectedprodID, this.reportservice.selectedversionID);
            this.location.replaceState("reports/limits?"+queryString);
            }
        });
    }

    // pagination
    pageChangedLimits(event) {
        this.loaded = false;
        this.p = event;
        this.page = event;
        this.maximums = [];
        this.getdata(this.reportservice.selectedprodID, this.reportservice.selectedversionID);
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    launchModal(event, maximum) {
        let btnId = event.target.id;
        this.selectedRowMaximum = maximum;
        if (maximum.selected != undefined && maximum.selected.length ==  this.numberConstant.ONE) {
            this.selectedMaximum = maximum.selectedConfig;
            if (this.selectedMaximum == undefined) {
                maximum.selectedConfig = maximum.selected[ this.numberConstant.SELECTEDOBJECT];
            }
            this.selectedMaximum.categoryName = maximum.name;
            this.selectedConfigName = maximum.selectedConfig.headername + " - "
                + maximum.selectedConfig.keyname;
            this.selectedConfigId = maximum.selectedConfig.id;
        }
        this.selectedAuthor = this.currentUser.email;
        this.modalProps.cancelButton = this.translateService.instant('cancel');
        this.modalProps.cancelBClass = "btn-outline";
        this.modalProps.hidden = false;
        switch (btnId) {
            case "deleteBtn":
                this.selectedBtnId = this.limitsconstant.deleteMaximumBtnID;
                if (maximum.selected != undefined && maximum.selected.length >  this.numberConstant.ONE) {
                    this.modalProps.title = maximum.selected.length + this.limitsconstant.deleteConfigAlertLabel;
                } else {
                    this.modalProps.title = this.translateService.instant('limit.delete') + this.selectedConfigName;
                }
                this.modalProps.bodyContent = this.translateService.instant('delMessage');
                this.modalProps.okButton = this.translateService.instant('limit.delete');
                this.modalProps.okBClass = "btn-danger";
                break;
            case "approveBtn":
                if (maximum.selected != undefined && maximum.selected.length >  this.numberConstant.ONE) {
                    this.modalProps.title = maximum.selected.length + this.limitsconstant.approveConfigAlertLabel;
                } else {
                    this.modalProps.title = this.translateService.instant('limit.approve') + this.selectedConfigName;
                }
                this.modalProps.bodyContent = this.translateService.instant('admin.EnableRelMsg');
                this.modalProps.okButton = this.translateService.instant('limit.approve');
                this.modalProps.okBClass = "btn-success";
                if (maximum.selected.length ==  this.numberConstant.ONE) {
                    for (let i: number =  this.numberConstant.ZERO; i < maximum.selectedConfig.approvals.length; i++) {
                        let found = maximum.selectedConfig.approvals[i].authorName.indexOf("@");
                        let authorname = this.currentUser.email;
                        if (found == this.numberConstant.MINUS_ONE) {
                            let arr = this.currentUser.email.split('@');
                            authorname = arr[ this.numberConstant.SELECTEDOBJECT];
                        }
                        if (maximum.selectedConfig.approvals[i].authorName === authorname) {
                            this.selectedAuthor = authorname;
                            if (maximum.selectedConfig.approvals[i].statusId === this.approvedStatus) {
                                this.alertService.warn(this.limitsconstant.alreadyApprovedConfigAlertLabel);
                                window.setTimeout(() => this.alertService.clear(),  this.numberConstant.ALERT_DELAY_3000);
                                return;
                            }
                            break;
                        }
                    }
                }
                break;
            case "deleteCategory":
                this.selectedBtnId = this.limitsconstant.deleteCategoryBtnID;
                this.selectedMaximum = maximum;
                this.modalProps.title = maximum.name + this.translateService.instant('deleteSelectLabel');

                if (maximum.configs != undefined && maximum.configs.length >  this.numberConstant.ZERO) {
                    this.modalProps.bodyContent = this.translateService.instant('categoryDelWarningMsg')
                    this.modalProps.hidden = true;
                } else {
                    this.modalProps.bodyContent = this.translateService.instant('categoryDelMsg');
                }
                if(this.checkIfSubCatgoryExists())
                {
                    this.modalProps.bodyContent = this.translateService.instant('WarningMsg_IfSubcategoryExists');
                    this.modalProps.hidden = true;
                }
                this.modalProps.okButton = this.translateService.instant('limit.delete')
                this.modalProps.okBClass = "btn-danger";
                break;
        }
        this.modalProps.state = true;
    }

    checkIfSubCatgoryExists():boolean {
        let containsSubCat = false;
        if(this.selectedMaximum.subcategoryId == undefined) {
            for (let i =  this.numberConstant.ZERO; i < this.maximums.length; i++) {
                if(this.maximums[i].categoryId == this.selectedMaximum.categoryId) {
                    if(this.maximums[i].subcategoryId != undefined) {
                        containsSubCat = true;
                        break;
                    }
                }
            }
        }
        return containsSubCat;
    }
    modalHandler(btnOutput: boolean) {
        if (btnOutput) {
            if (this.modalProps.okButton === this.translateService.instant('limit.delete') && this.selectedBtnId == this.limitsconstant.deleteMaximumBtnID) {
                if (this.selectedRowMaximum.selected.length ==  this.numberConstant.ONE) {
                    this.deleteConfig(this.selectedConfigId);
                } else {
                    this.bulkDelete();
                }
            } else if (this.modalProps.okButton === this.translateService.instant('limit.delete') &&
                this.selectedBtnId == this.limitsconstant.deleteCategoryBtnID) {
                this.deleteCategory(this.selectedMaximum);
            } else if (this.modalProps.okButton === this.translateService.instant('limit.approve')) {
                if (this.selectedRowMaximum.selected.length ==  this.numberConstant.ONE) {
                    this.approveConfig(this.selectedConfigId, this.selectedAuthor);
                } else {
                    this.bulkApprove();
                }
            }
        } else {
            this.alertService.warn(this.modalProps.title + this.translateService.instant('noChnagesAlertLabel'));
            window.setTimeout(() => this.alertService.clear(),  this.numberConstant.ALERT_DELAY_3000);
        }
    }

    approveConfig(id: number, author: String) {
        let altAuthorComps = author.split("@");
        let altAuthor = altAuthorComps[ this.numberConstant.SELECTEDOBJECT];
        let isApprovalAllowed = false;
        let index =  this.numberConstant.ZERO;
        for (let approval of this.selectedMaximum.approvals) {
            if (approval.authorName === author || approval.authorName === altAuthor) {
                isApprovalAllowed = true;
                this.selectedMaximum.approvals[index].statusId =  this.numberConstant.APPROVEDSTATUS;
                this.selectedMaximum.approvals[index].status = "Approved";
            }
            index++;
        }
        if (isApprovalAllowed) {
            this.selectedMaximum.updatedBy = author;
            this.selectedMaximum.type = this.translateService.instant('limit.approve');
            this.selectedMaximum.productId = this.reportservice.selectedprodID;
            this.selectedMaximum.versionId = this.reportservice.selectedversionID;
            this.selectedMaximum.subcategoryId = this.reportservice.subcatId;
            if (this.selectedMaximum.subcategoryId === undefined) {
                this.selectedMaximum.subcategoryId =  this.numberConstant.ZERO;
            }
            if (this.selectedMaximum.categoryId === undefined) {
                this.selectedMaximum.categoryId = this.numberConstant.ZERO;
            }
            this.selectedMaximum["vmwareProductName"] = this.reportservice.selectedprodName;
            this.selectedMaximum["vmwareProductVersionName"] = this.reportservice.selectedverName;
            this.limitsService.addUpdateConfigs(this.selectedMaximum)
                .subscribe(approved => {
                    this.zone.run(() => {
                        if (approved.status && approved.status === "OK") {
                            this.alertService.success(this.modalProps.title + " - " + approved.message);
                            window.setTimeout(() => this.alertService.clear(),  this.numberConstant.ALERT_DELAY_3000);
                            this.selectedMaximum.statusName = "Approved";
                            this.selectedMaximum.id = id;
                        } else {
                            this.alertService.warn(this.modalProps.title + this.limitsconstant.noSucessLabel);
                            window.setTimeout(() => this.alertService.clear(), this.numberConstant.ALERT_DELAY_3000);
                        }
                        this.getdata(this.reportservice.selectedprodID, this.reportservice.selectedversionID);
                    });
                },
                    err => {
                        this.alertService.warn(this.modalProps.title + this.limitsconstant.noSucessLabel);
                        window.setTimeout(() => this.alertService.clear(), this.numberConstant.ALERT_DELAY_3000);
                        console.log(err);
                        this.getdata(this.reportservice.selectedprodID, this.reportservice.selectedversionID);
                    });
        } else {
            this.alertService.warn(this.modalProps.title + this.limitsconstant.notInApproverListLabel);
            window.setTimeout(() => this.alertService.clear(), this.numberConstant.ALERT_DELAY_3000);
        }

    }

    deleteConfig(id: number) {
        this.selectedMaximum.statusName = this.translateService.instant('limit.delete');
        this.selectedMaximum.id = id;
        this.selectedMaximum.productId = this.reportservice.selectedprodID;
        this.selectedMaximum.versionId = this.reportservice.selectedversionID;
        this.selectedMaximum.subcategoryId = this.reportservice.subcatId;
        if (this.selectedMaximum.subcategoryId === undefined) {
            this.selectedMaximum.subcategoryId = this.numberConstant.ZERO;
        }
        if (this.selectedMaximum.categoryId === undefined) {
            this.selectedMaximum.categoryId = this.numberConstant.ZERO;
        }
        this.selectedMaximum["vmwareProductName"] = this.reportservice.selectedprodName;
        this.selectedMaximum["vmwareProductVersionName"] = this.reportservice.selectedverName;
        this.limitsService.deleteConfigurations(this.selectedMaximum)
            .subscribe(deleted => {
                this.zone.run(() => {
                    if (deleted.status && deleted.status === "OK") {
                        this.alertService.success(this.limitsconstant.configDeleteSucessAlertLabel);
                        window.setTimeout(() => this.alertService.clear(), this.numberConstant.ALERT_DELAY_3000);
                        this.getdata(this.reportservice.selectedprodID, this.reportservice.selectedversionID);
                    } else {
                        this.alertService.warn(this.limitsconstant.configDeleteFailureAlertLabel);
                        window.setTimeout(() => this.alertService.clear(), this.numberConstant.ALERT_DELAY_3000);
                    }

                });
            },
                err => {
                    console.log(err)
                });
    }

    fillSelectedForEditAction(selectedConfig: any) {
        this.initializeConfiguration();
        this.selectedMaximum = selectedConfig.selectedConfig;
        this.selectedMaximum.categoryName = selectedConfig.name;
        this.reportservice.catId = selectedConfig.categoryId;
        this.selectedConfigId = selectedConfig.selectedConfig.id;
        this.selectedConfigStatusId = selectedConfig.selectedConfig.statusId;
        this.approvals = selectedConfig.selectedConfig.approvals;
        this.reportservice.subcatId = selectedConfig.subcategoryId;
        if (this.reportservice.catId == null) {
            this.reportservice.catId = this.numberConstant.ZERO;
        }
        if (this.reportservice.subcatId == null) {
            this.reportservice.subcatId = this.numberConstant.ZERO;
        }
        this.getAttributeHeaders(this.reportservice.catId, this.reportservice.subcatId,
            selectedConfig.selectedConfig.attrHeaderId);
        this.getAttributeKeys(selectedConfig.selectedConfig.attrKeyId);
        let selectedConfigdata = selectedConfig.selectedConfig;
        this.addConfigData.title = this.limitsconstant.editConfigLabel;
        if (this.selectedConfigStatusId == this.limitsconstant.statusID) {
            this.addConfigData.title = this.addConfigData.title + this.translateService.instant('editSubtitle');
        }
        this.addConfigData.modalOptionEnabled = true;
        this.addConfigData.subTitle = selectedConfig.name;
        for (let item of selectedConfigdata.approvals) {
            if (item.authorTypeId === AuthorTypes.productManager) {
                this.addConfigData.elements[this.numberConstant.PRODAUTHOR].selectedValue = item.authorName;
            }
            if (item.authorTypeId === AuthorTypes.devMember) {
                this.addConfigData.elements[this.numberConstant.DEVAUTHOR].selectedValue = item.authorName;
            }
            if (item.authorTypeId === AuthorTypes.qeMember) {
                this.addConfigData.elements[this.numberConstant.QEAUTHOR].selectedValue = item.authorName;
            }
            if (item.authorTypeId === AuthorTypes.performanceMember) {
                this.addConfigData.elements[this.numberConstant.PERFORMANCEAUTHOR].selectedValue = item.authorName;
            }
        }
        this.addConfigData.elements[this.numberConstant.TARGET].selectedValue = selectedConfigdata.attrTargetValue;
        this.addConfigData.elements[this.numberConstant.ATTRIBUTE].selectedValue = selectedConfigdata.attrValue;
        this.addConfigData.elements[this.numberConstant.TEST].selectedValue = selectedConfigdata.testPlan;
        this.addConfigData.elements[this.numberConstant.PMT].selectedValue = selectedConfigdata.pmt;
        let internal = selectedConfigdata.internal;
        if (internal === "No") {
            this.addConfigData.elements[this.numberConstant.INTERNAL].options[this.numberConstant.ZERO].isChecked = false;
            this.addConfigData.elements[this.numberConstant.INTERNAL].options[this.numberConstant.ONE].isChecked = true;
        } else {
            this.addConfigData.elements[this.numberConstant.INTERNAL].options[this.numberConstant.ZERO].isChecked = true;
            this.addConfigData.elements[this.numberConstant.INTERNAL].options[this.numberConstant.ONE].isChecked = false;
        }
        this.addConfigData.elements[this.numberConstant.DESCRIPTION].selectedValue = selectedConfigdata.description;
        this.addConfigData.elements[this.numberConstant.SELECTEDOBJECT].options = this.headerslist;
        this.addConfigData.elements[this.numberConstant.KEYOBJECT].options = this.keylist;
        this.addConfigData.okButton = this.translateService.instant('save');
        this.addConfigData.state = true;
    }
    setCatId(maximum) {
        this.reportservice.catId = maximum.categoryId;
        this.reportservice.subcatId = maximum.subcategoryId;
        if (this.reportservice.catId == null) {
            this.reportservice.catId = this.numberConstant.ZERO;
        }
        if (this.reportservice.subcatId == null) {
            this.reportservice.subcatId = this.numberConstant.ZERO;
        }
        this.getAttributeHeaders(this.reportservice.catId, this.reportservice.subcatId, this.numberConstant.ZERO);
        this.getAttributeKeys(this.numberConstant.ZERO);

    }
    addConfigAction(maximum) {
        this.addConfigData.title = this.translateService.instant('addMaximumTitle');
        this.addConfigData.subTitle = maximum.name;
        this.addConfigData.modalOptionEnabled = false;
        this.setCatId(maximum);
        let arr: any[] = this.headerslist as Array<any>;
        this.addConfigData.elements[this.numberConstant.SELECTEDOBJECT].options = this.headerslist;
        this.addConfigData.elements[this.numberConstant.SELECTEDOBJECT].selectedValue = this.headerslist[this.numberConstant.SELECTEDOBJECT];
        this.addConfigData.elements[this.numberConstant.KEYOBJECT].options = this.keylist;
        this.addConfigData.elements[this.numberConstant.KEYOBJECT].selectedValue = this.keylist[this.numberConstant.SELECTEDOBJECT];
        this.addConfigData.okButton = this.translateService.instant('addString')
        this.addConfigData.state = true;
    }

    getAttributeHeaders(catId, subcatId, headerId): void {
        let arr: any = new Array();
        arr.push({
            id: this.numberConstant.ZERO, value: this.translateService.instant('selectHeaderLabel')
        });
        let editArr: any = new Array();
        this.limitsService.getHeaders(parseInt(catId, this.numberConstant.TEN), parseInt(subcatId, this.numberConstant.TEN),
            this.reportservice.selectedprodID, this.reportservice.selectedversionID)
            .subscribe(headers => {
                if (headers.length === this.numberConstant.ZERO) {
                } else {
                    headers.forEach(element => {
                        if (element.attrHeader.length > this.numberConstant.ZERO) {
                            arr.push({
                                id: element.id, value: element.attrHeader
                            });
                        }
                        editArr.push({
                            id: element.id, value: element.attrHeader
                        });
                    });
                    if (headerId == this.numberConstant.ZERO) {
                        this.setheadeValues(headerId, arr);
                    } else {
                        this.setheadeValues(headerId, editArr);
                    }
                }
            },
                err => {
                    console.log(err)
                });
        this.headerslist = arr;
    }

    setheadeValues(headerId: number, arr) {
        if (headerId === this.numberConstant.ZERO) {
            this.addConfigData.elements[this.numberConstant.SELECTEDOBJECT].selectedValue = arr[this.numberConstant.SELECTEDOBJECT];
        } else {
            arr.forEach(element => {
                if (element.id === headerId) {
                    this.addConfigData.elements[this.numberConstant.SELECTEDOBJECT].selectedValue = element;
                    return;
                }
            });
        }
    }

    setkeyValues(keyId, arr) {
        if (keyId === this.numberConstant.ZERO) {
            this.addConfigData.elements[this.numberConstant.KEYOBJECT].selectedValue = arr[this.numberConstant.SELECTEDOBJECT];
        } else {
            arr.forEach(element => {
                if (element.id === keyId) {
                    this.addConfigData.elements[this.numberConstant.KEYOBJECT].selectedValue = element;
                }
            });
        }
    }

    getAttributeKeys(keyId): any {
        let arr: any = new Array();
        this.limitsService.getAttrKeys(this.reportservice.selectedprodID)
            .subscribe(keys => {
                if (keys.length === this.numberConstant.ZERO) {
                } else {
                    keys.forEach(element => {
                        arr.push({
                            id: element.id, value: element.attributeKey
                        });
                    });
                    this.setkeyValues(keyId, arr);
                }

            },
                err => {
                    console.log(err)
                });
        this.keylist = arr;
        return arr;
    }

    limitformModalHandler(btnOutput: boolean) {
        let title = this.translateService.instant('configAlertLabel') + this.addConfigData.subTitle;
        if (btnOutput) {
            let maxattrdata: ConfigMaxSetAttributes = new ConfigMaxSetAttributes();
            maxattrdata.cmSetCategoryId = this.reportservice.catId;
            if (this.addConfigData.elements[this.numberConstant.ZERO] != undefined &&
                this.addConfigData.elements[this.numberConstant.ZERO].selectedValue != undefined) {
                maxattrdata.attrHeaderId = this.addConfigData.elements[this.numberConstant.ZERO].selectedValue.id;
            }
            maxattrdata.attrKeyId = this.addConfigData.elements[this.numberConstant.KEYOBJECT].selectedValue.id;
            maxattrdata.keyname = this.addConfigData.elements[this.numberConstant.KEYOBJECT].selectedValue.value;
            maxattrdata.attrTargetValue = this.addConfigData.elements[this.numberConstant.TARGET].selectedValue;
            maxattrdata.attrValue = this.addConfigData.elements[this.numberConstant.ATTRIBUTE].selectedValue;
            maxattrdata.productId = this.reportservice.selectedprodID;
            maxattrdata.versionId = this.reportservice.selectedversionID;
            maxattrdata.categoryId = this.reportservice.catId;
            maxattrdata.subcategoryId = this.reportservice.subcatId;
            if (this.addConfigData.elements[this.numberConstant.INTERNAL].options[this.numberConstant.ZERO].isChecked === true) {
                maxattrdata.internal = true;
            } else {
                maxattrdata.internal = false;
            }
            maxattrdata.description = this.addConfigData.elements[this.numberConstant.DESCRIPTION].selectedValue;
            maxattrdata.lastUpdate = new Date();
            maxattrdata.pmt = this.addConfigData.elements[this.numberConstant.PMT].selectedValue;
            maxattrdata.testPlan = this.addConfigData.elements[this.numberConstant.TEN].selectedValue;
            maxattrdata.updatedBy = this.user;
            let performauthor: ConfigMaxSetAttrAuthors =
                this.setAuthor(this.addConfigData.elements[this.numberConstant.PERFORMANCEAUTHOR].selectedValue, AuthorTypes.performanceMember);
            let qeauthor: ConfigMaxSetAttrAuthors =
                this.setAuthor(this.addConfigData.elements[this.numberConstant.QEAUTHOR].selectedValue, AuthorTypes.qeMember);
            let prodauthor: ConfigMaxSetAttrAuthors =
                this.setAuthor(this.addConfigData.elements[this.numberConstant.PRODAUTHOR].selectedValue, AuthorTypes.productManager);
            let devauthor: ConfigMaxSetAttrAuthors =
                this.setAuthor(this.addConfigData.elements[this.numberConstant.DEVAUTHOR].selectedValue, AuthorTypes.devMember);
                
            maxattrdata.approvals = this.getAuthorsList(performauthor, qeauthor, prodauthor, devauthor,this.numberConstant.ZERO);
            if (this.addConfigData.okButton === this.translateService.instant('save')) {
                // Update config maximum
                for (let item of this.approvals) {
                    if (item.authorTypeId === AuthorTypes.productManager) {
                        prodauthor = item;
                        prodauthor.authorName = this.addConfigData.elements[this.numberConstant.PRODAUTHOR].selectedValue;
                    }
                    if (item.authorTypeId === AuthorTypes.devMember) {
                        devauthor = item;
                        devauthor.authorName = this.addConfigData.elements[this.numberConstant.DEVAUTHOR].selectedValue;
                    }
                    if (item.authorTypeId === AuthorTypes.qeMember) {
                        qeauthor = item;
                        qeauthor.authorName = this.addConfigData.elements[this.numberConstant.QEAUTHOR].selectedValue;
                    }
                    if (item.authorTypeId === AuthorTypes.performanceMember) {
                        performauthor = item;
                        performauthor.authorName = this.addConfigData.elements[this.numberConstant.PERFORMANCEAUTHOR].selectedValue;
                    }
                }
                maxattrdata.id = this.selectedConfigId;
                title = this.translateService.instant('configAlertLabel') + this.addConfigData.subTitle;
                this.selectedMaximum.statusName = this.translateService.instant('update');
                maxattrdata.approvals =this.getAuthorsList(performauthor, qeauthor, prodauthor, devauthor,this.selectedConfigId);
                
                maxattrdata["type"] = this.translateService.instant('update');
            } else { // Add new config maximum
                this.selectedMaximum = maxattrdata;
                this.selectedMaximum.statusName = this.translateService.instant('newStatus');
                this.selectedMaximum.categoryName = this.addConfigData.subTitle;
                if (this.addConfigData.elements[this.numberConstant.ZERO] != undefined &&
                    this.addConfigData.elements[this.numberConstant.ZERO].selectedValue != undefined) {
                    this.selectedMaximum.headername = this.addConfigData.elements[this.numberConstant.SELECTEDOBJECT].selectedValue.value;
                }
                this.selectedMaximum.keyname = this.addConfigData.elements[this.numberConstant.KEYOBJECT].selectedValue.value;
                maxattrdata["type"] = this.translateService.instant('addString');
            }
            // assign team member function
            if (this.assignTeamMemberData.state == true) {
                maxattrdata = this.selectedAssignedMax;
                let assigneeEmail = this.assignTeamMemberData.elements[this.numberConstant.SELECTEDOBJECT].selectedValue;
                maxattrdata.productId = this.reportservice.selectedprodID;
                maxattrdata.versionId = this.reportservice.selectedversionID;
                maxattrdata.categoryId = this.reportservice.catId;
                maxattrdata.subcategoryId = this.reportservice.subcatId;
                let teamMemberAuthor: ConfigMaxSetAttrAuthors =
                    this.setAuthor(assigneeEmail, AuthorTypes.teamMember);
                teamMemberAuthor.status = this.translateService.instant('pendingStatus');
                teamMemberAuthor.statusId = this.numberConstant.ONE;
                teamMemberAuthor.authorType = "Team_Member";
                teamMemberAuthor.configMaxSetAttrId = this.configSetId;
                maxattrdata["type"] = this.translateService.instant('assign');
                maxattrdata.approvals.push(teamMemberAuthor);
            }
            this.selectedAuthor = this.currentUser.email;
            maxattrdata["vmwareProductName"] = this.reportservice.selectedprodName;
            maxattrdata["vmwareProductVersionName"] = this.reportservice.selectedverName;
            let responseObj:any;
            this.limitsService.addUpdateConfigs(maxattrdata)
                .subscribe(created => {
                    this.zone.run(() => {
                        if (created.status && created.status === "OK") {
                            this.alertService.success(title + " - " + created.message);
                            window.setTimeout(() => this.alertService.clear(), this.numberConstant.ALERT_DELAY_3000);
                            this.getdata(this.reportservice.selectedprodID, this.reportservice.selectedversionID);
                        } else {
                                this.alertService.warn(title + this.translateService.instant('updateAlertFailureLabel'));
                                window.setTimeout(() => this.alertService.clear(), this.numberConstant.ALERT_DELAY_3000);
                        }
                    });
                },
                    err => {
                        console.log(err);
                        responseObj = err;
                        if (responseObj.status && responseObj.status === this.limitsconstant.HTTP_STATUS_CONFLICT) {
                            this.alertService.warn(title  + this.limitsconstant.duplicateAlertFailureLabel);
                            window.setTimeout(() => this.alertService.clear(), this.numberConstant.ALERT_DELAY_3000);
                        } else {
                            this.alertService.warn(title + this.translateService.instant('updateAlertFailureLabel'));
                            window.setTimeout(() => this.alertService.clear(), this.numberConstant.ALERT_DELAY_3000);
                        }
                    });
        } else {
            this.alertService.warn(title + this.translateService.instant('noChnagesAlertLabel'));
            window.setTimeout(() => this.alertService.clear(), this.numberConstant.ALERT_DELAY_3000);
        }
        this.initializeConfiguration();
    }

    fnassignTeamMember(config: any, maximum: any) {
        this.reportservice.catId = maximum.categoryId;
        this.reportservice.subcatId = maximum.subcategoryId;
        if (this.reportservice.catId == null) {
            this.reportservice.catId = this.numberConstant.ZERO;
        }
        if (this.reportservice.subcatId == null) {
            this.reportservice.subcatId = this.numberConstant.ZERO;
        }
        this.configSetId = config.id;
        this.selectedAssignedMax = config;
        this.assignTeamMemberData.state = true;
    }

    chatModalHandler(btnOutput: boolean) {
        if (btnOutput) {
            let authortype: number = this.numberConstant.ZERO;
            for (let i: number = this.numberConstant.ZERO; i < this.selectedAttribute.approvals.length; i++) {
                var found = this.selectedAttribute.approvals[i].authorName.indexOf("@");
                var authorname = this.currentUser.email;
                if (found == this.numberConstant.MINUS_ONE) {
                    var arr = this.currentUser.email.split('@');
                    authorname = arr[this.numberConstant.ZERO];
                }
                if (this.selectedAttribute.approvals[i].authorName === authorname) {
                    authortype = this.selectedAttribute.approvals[i].authorTypeId;
                    break;
                }
            }
            if (authortype > this.numberConstant.ZERO) {
                this.limitsService.updateAttrAuthors(this.selectedAttribute.id,
                    authortype, this.chatModalProps.selectedValue, authorname).subscribe(status => {
                        let statusObj: any = status;
                        if (statusObj.status === "OK") {
                            this.alertService.success(statusObj.message);
                            window.setTimeout(() => this.alertService.clear(), this.numberConstant.ALERT_DELAY_3000);
                        }
                    },
                        err => {
                            let errMsg: any = err.json();
                            this.alertService.warn(errMsg.message);
                            window.setTimeout(() => this.alertService.clear(), this.numberConstant.ALERT_DELAY_3000);
                        });
            } else {
                this.alertService.warn(this.limitsconstant.authorNotAssignedAlertLabel);
                window.setTimeout(() => this.alertService.clear(), this.numberConstant.ALERT_DELAY_3000);
            }
        } else {
            this.alertService.warn(this.translateService.instant('commentsUpdateAlertFailureLabel'));
            window.setTimeout(() => this.alertService.clear(), this.numberConstant.ALERT_DELAY_3000);
        }


    }

    opHandler(onCheck: boolean) {
    }

    setAuthor(name, type): ConfigMaxSetAttrAuthors {
        let author: ConfigMaxSetAttrAuthors = null;
        if(name != null && name.length >this.numberConstant.ZERO) {
        author = new ConfigMaxSetAttrAuthors();
        author.authorName = name;
        author.authorTypeId = type;
        author.lastUpdate = new Date();
        author.updatedBy = this.user;
        }
        return author;
    }
    launchCreationModel(maximum, configs) {
        if (this.maximums == null || (this.maximums != null && this.maximums.length == this.numberConstant.ZERO)
            || configs == null) {
            this.newCreationData = this.createMaximumData;
            this.newCreationData.state = true;
        } else if (configs != null && configs.length === this.numberConstant.ZERO) {
            this.selectedMaximum = maximum;
            this.addConfigAction(maximum);
        }
    }
    getProductArray(array: any, prod, copy, cat): any {
        let arr: any = new Array();
        arr.push({ id: this.numberConstant.ZERO, value: this.translateService.instant('select'), cat: cat, isprod: prod, iscopy: copy });
        array.forEach(element => {
            arr.push({ id: element.id, value: element.rmVmwProduct, cat: cat, isprod: prod, iscopy: copy });
        });
        return arr;
    }

    initializeConfiguration(): void {
        let header = ElementData.getattrSelectdata(this.translateService.instant('label'), false,this.translateService.instant('enter'),this.translateService.instant('name'));
        let headernew = ElementData.getTextandButton(this.translateService.instant('newLabel'), true);
        let attrName = ElementData.getattrSelectdata(this.translateService.instant('item'), false,this.translateService.instant('enter'),this.translateService.instant('name'));
        let attrNamenew = ElementData.getTextandButton(this.translateService.instant('newConfiguration'), true);
        let performanceMember = ElementData.getVersiondata(this.translateService.instant('manLimits.performanceMember'));
        let qeMember = ElementData.getVersiondata(this.translateService.instant('manLimits.qeMember'));
        let productManager = ElementData.getVersiondata(this.translateService.instant('manLimits.prodManager'));
        let devMember = ElementData.getVersiondata(this.translateService.instant('manLimits.devMember'));
        let targetValue = ElementData.getattrdata(this.translateService.instant('manLimits.targetLimit'));
        let publishvalue = ElementData.getattrdata(this.translateService.instant('manLimits.publishLimit'));
        let testplan = ElementData.getVersiondata(this.translateService.instant('manLimits.testLimit'));
        let pmt = ElementData.getVersiondata(this.translateService.instant('manLimits.jiraPmt'));
        let isInternal = ElementData.getIsInternaldata(this.translateService.instant('review.keepInternal'),this.translateService.instant('yes'),this.translateService.instant('no'));
        let desc = ElementData.getDescData(this.translateService.instant('viewLimits.description'));
        this.arr = [header, headernew, attrName, attrNamenew,
            performanceMember, qeMember, productManager, devMember, targetValue,
            publishvalue, testplan, pmt, isInternal, desc];
        this.addConfigData = {
            state: false,
            backdrop: true,
            title: this.translateService.instant('addMaximumTitle'),
            subTitle: "Fill in the details",
            cancelButton: this.translateService.instant('cancel'),
            okButton: this.translateService.instant('addString'),
            cancelBClass: "btn-outline",
            okBClass: "btn-primary",
            elements: this.arr
        }
    }

    formModalHandlerForConfigMax(btnOutput: boolean) {
        if (btnOutput) {
            let configmaxset: ConfigMaxSet = new ConfigMaxSet();
            configmaxset.title = this.updateProjectData.elements[this.numberConstant.ONE].selectedValue.value;
            configmaxset.vmwProductId = this.updateProjectData.elements[this.numberConstant.SELECTEDOBJECT].selectedValue.id;
            configmaxset.vmwProductReleaseId = new Array();
            configmaxset.vmwProductReleaseId.push(this.updateProjectData.elements[this.numberConstant.SELECTEDVERSION].selectedValue.id);
            configmaxset.coneProductReleaseId = new Array();
            if (this.updateProjectData.elements[this.numberConstant.TWO].options[this.numberConstant.SELECTEDOBJECT].isChecked === false) {
                configmaxset.newVersion = false;
                configmaxset.cloneProductId = this.updateProjectData.elements[this.numberConstant.SELECTEDPRODUCT].selectedValue.id
                configmaxset.coneProductReleaseId.push(this.updateProjectData.elements[this.numberConstant.CLONEVERSION].selectedValue.id);
            } else {
                configmaxset.cloneProductId = this.numberConstant.ZERO;
                configmaxset.coneProductReleaseId = [];
                configmaxset.newVersion = true;
            }
            configmaxset.publishedDate = new Date(this.updateProjectData.elements[this.numberConstant.PUBLISHDATE].selectedValue);
            configmaxset.comments = this.updateProjectData.elements[this.numberConstant.COMMENTS].selectedValue;
            configmaxset.lastUpdate = new Date();
            configmaxset.statusId = parseInt(this.updateProjectData.elements[this.numberConstant.STATUS].selectedValue, this.numberConstant.TEN);
            configmaxset.id = parseInt(this.updateProjectData.elements[this.numberConstant.SELECTEDCONFIGSET].selectedValue, this.numberConstant.TEN);
            let currentUser = JSON.parse(localStorage.getItem('currentUser'));
            configmaxset.updatedBy = currentUser.userName;
            this.limitsService.updateConfigmaxset(configmaxset)
                .subscribe(response => {
                    this.zone.run(() => { // <== added
                        if (response.status && response.status === "OK") {
                            this.alertService.success(this.updateProjectData.title + this.limitsconstant.configMaxSetUpdateSuccessAlertLabel);
                            window.setTimeout(() => this.alertService.clear(), this.numberConstant.ALERT_DELAY_3000);
                        } else {
                            this.alertService.warn(this.updateProjectData.title + this.limitsconstant.configMaxSetUpdateFailureAlertLabel);
                            window.setTimeout(() => this.alertService.clear(), this.numberConstant.ALERT_DELAY_3000);
                        }

                    });
                },
                    err => {
                        console.log(err)
                    });



        } else {
            this.alertService.warn(this.updateProjectData.title + this.translateService.instant('revertAlertLabel'));
            window.setTimeout(() => this.alertService.clear(), this.numberConstant.ALERT_DELAY_3000);
        }
    }

    setConfigdata(title, prodId: number, versionId: number, state: boolean): void {
        this.limitsService.postConfigmaxSet(prodId, versionId)
            .subscribe(data => {
                this.zone.run(() => { // <== added
                    let configdata: any = data[this.numberConstant.ZERO];
                    if (configdata != null || configdata != undefined) {
                        let prodData = ElementData.getproddata(this.translateService.instant('product'), false,this.translateService.instant('enter'),this.translateService.instant('name'));
                        let arrvalues: any = new Array();
                        this.reportservice.selectedprods.forEach(element => {
                            arrvalues.push({ id: element.id, value: element.rmVmwProduct, isprod: true });
                        });
                        prodData.options = arrvalues;
                        prodData.selectedValue = this.setarrayData(arrvalues, configdata.vmwProduct.id);
                        let versionData = ElementData.getselecversiondata(this.translateService.instant('manLimits.version'), false, this.translateService.instant('enter'),this.translateService.instant('name'));
                        let versionarray: any = new Array();
                        this.reportservice.selectedversions.forEach(element => {
                            versionarray.push({ id: element.id, value: element.rmVmwPrdRelVersion });
                        });
                        versionData.options = versionarray;
                        versionData.selectedValue = this.setarrayData(versionarray,
                            configdata.vmwProductRelease.id);
                        let pubdate = ElementData.getCurrentDate(this.translateService.instant('manageRelModal.publishDate'));
                        let desc = ElementData.getDescData(this.translateService.instant('viewLimits.description'));
                        pubdate.selectedValue = this.setDateForConfig(configdata.publishedDate);
                        desc.selectedValue = configdata.comments;
                        let status = ElementData.getselecversiondata("status", true,this.translateService.instant('enter'),this.translateService.instant('name'));
                        let id = ElementData.getselecversiondata("id", true,this.translateService.instant('enter'),this.translateService.instant('name'));
                        status.selectedValue = configdata.statusId;
                        id.selectedValue = configdata.id;
                        let clonedata = ElementData.getedidata(this.translateService.instant('update'),this.translateService.instant('adminGridOption.edit'),this.translateService.instant('clone'));
                        let copyprodata = ElementData.getproddata(this.translateService.instant('manLimits.editConfigBoxCloneFrom'), true,this.translateService.instant('enter'),this.translateService.instant('name'));
                        let arrvals: any = new Array();
                        this.reportservice.selectedprodsInCfSet.forEach(element => {
                            arrvals.push({ id: element.id, value: element.rmVmwProduct, isprod: false });
                        });
                        copyprodata.options = arrvals;
                        copyprodata.selectedValue = arrvals[this.numberConstant.ZERO];
                        let copyVerData = ElementData.getselecversiondata(this.translateService.instant('manLimits.editConfigBoxCloneVersion'), true,this.translateService.instant('enter'),this.translateService.instant('name'));
                        copyVerData.options = this.copyversions;
                        copyVerData.selectedValue = this.copyversions[this.numberConstant.ZERO];
                        let arr = [prodData, versionData, clonedata, copyprodata, copyVerData, pubdate,
                            desc, status, id];
                        this.initializeproductData(versionData.selectedValue.value, arr, state);

                    } else {
                        this.alertService.warn(this.title + this.limitsconstant.editConfigMaxSetAlertLabel);
                        window.setTimeout(() => this.alertService.clear(), this.numberConstant.ALERT_DELAY_3000);

                    }
                });

            },
                err => {
                    console.log(err)
                    this.alertService.warn(this.title + this.limitsconstant.editConfigMaxSetAlertLabel);
                    window.setTimeout(() => this.alertService.clear(), this.numberConstant.ALERT_DELAY_3000);
                });
    }

    setDateForConfig(date: any): string {
        var date: any = new Date(date);
        var year = date.getUTCFullYear();
        var month = date.getUTCMonth() + this.numberConstant.ONE;
        var day = date.getUTCDate();
        var dateString = year + "-" + month + "-" + day;
        if (day < this.numberConstant.TEN) {
            dateString = year + "-" + month + "-" + this.numberConstant.ZERO + day;
        }
        return dateString;
    }
    setarrayData(array, id): any {
        let element: any = "";
        for (var index = this.numberConstant.ZERO; index < array.length; index++) {
            if (array[index].id === id) {
                element = array[index];
                return element;
            }
        }
        return element;
    }
    initializeproductData(title, elementsarr: any, state: boolean) {
        this.updateProjectData = {
            state: state,
            backdrop: true,
            title: this.translateService.instant('update') + " " + title,
            subTitle: "",
            cancelButton: this.translateService.instant('cancel'),
            okButton: this.translateService.instant('update'),
            cancelBClass: "btn-outline",
            okBClass: "btn-success",
            elements: elementsarr,
            isMaximum: false
        };
    }

    openEditWindow() {
        this.copyversions = this.getSelProductVersions(this.reportservice.selectedprodID, false, this.numberConstant.HASCONFIGSET);
    }
    initializeHeaders() {
        let headerName = new HeaderData(this.translateService.instant('manLimits.dataGridLabels'), "moreWidth", "itemFilter", false);
        let attrName = new HeaderData(this.translateService.instant('item'), "", "", false);
        let testplan = new HeaderData(this.translateService.instant('manLimits.testLimit'), "", "", false);
        let pmt = new HeaderData(this.translateService.instant('manLimits.jiraPmt'), "", "", true);
        let isinternal = new HeaderData(this.translateService.instant('review.keepInternal'), "", "", false);
        let target = new HeaderData(this.translateService.instant('manLimits.targetLimit'), "", "", false);
        let publish = new HeaderData(this.translateService.instant('manLimits.publishLimit'), "", "", false);
        let comment = new HeaderData(this.translateService.instant('limit.comment'), "", "", false);
        this.dataHeaders = [headerName, attrName, testplan, pmt, isinternal, target, publish, comment];

    }

    initializeChatModal(arr) {
        this.chatModalProps = {
            state: false,
            backdrop: true,
            hasCommentAccess: true,
            cancelButton: this.translateService.instant('cancel'),
            submitButton: this.translateService.instant('submit'),
            cancelBClass: "btn-outline",
            submitBClass: "btn-success",
            commentPlaceHolder: this.translateService.instant('revPubl.dataGridComment'),
            selectedValue: "",
            conversations: arr
        };
    }

    showChatModal(config: any): void {
        this.selectedAttribute = config;
        this.getAuthorComments(config.id.toString());
    }
    getAuthorComments(attrrId: String): void {
        let arr: any = new Array();
        this.limitsService.getAttrAuthors(attrrId)
            .subscribe(authors => {
                if (authors === undefined || authors.length === this.numberConstant.ZERO) {
                    authors = [];
                }
                this.initializeChatModal(authors);
                this.chatModalProps.state = true
            },
                err => {
                    console.log(err);
                });
    }

    showComponentsAuthorized(resourceName): boolean {
        let hideComponent = true;
        if (this.reportservice.resorceactions === undefined ||
            this.reportservice.resorceactions.length === this.numberConstant.ZERO) {
            return true;
        }
        return hideComponent = this.authservice.checkaction(resourceName);
    }

    getTotalDataCount(prodid: number, verid: number): void {
        if (this.reportservice.categoriesArray == null || this.reportservice.categoriesArray.length == this.numberConstant.ZERO) {
            this.alertService.warn(this.translateService.instant('selectMaximum'));
            window.setTimeout(() => this.alertService.clear(), this.numberConstant.ALERT_DELAY_1000);
            this.loaded = true;
            this.maximums = [];
            this.totalRec = this.numberConstant.ZERO;
            return;
        }
        let categoriesData: CategoriesRecord = this.reportservice.getCategorieData(prodid, verid);
        this.limitsService.getConfigMaximums(categoriesData,
            this.numberConstant.ZERO, this.numberConstant.ZERO, true,true)
            .subscribe(responseData => {
                if (responseData.ok === true) {
                    let releases = responseData.json();
                    this.totalRec = releases.length;
                }
            },
                err => {
                    console.log(err);
                    this.totalRec = this.numberConstant.ZERO;
                });
    }

    getdata(prodid: number, verid: number): void {
        if (this.reportservice.categoriesArray == null || this.reportservice.categoriesArray.length === this.numberConstant.ZERO) {
            this.alertService.warn(this.translateService.instant('selectMaximum'));
            window.setTimeout(() => this.alertService.clear(),this.numberConstant.ALERT_DELAY_1000);
            this.loaded = true;
            this.maximums = [];
            return;
        }
        let categoriesData: CategoriesRecord = this.reportservice.getCategorieData(prodid, verid);
        this.limitsService.getConfigMaximums(categoriesData,
            this.page, this.itemsPerPage, true,false)
            .subscribe(responseData => {
                this.loaded = true;
                if (responseData.ok === true) {
                    let releases = responseData.json();
                    releases.forEach(element => {
                        element.selected = [];
                    });
                    this.maximums = releases;
                }
            },
                err => {
                    console.log(err);
                    this.loaded = true;
                    this.maximums = [];
                    this.alertService.warn(this.limitsconstant.noConfigsFoundLabel);
                    window.setTimeout(() => this.alertService.clear(), this.numberConstant.ALERT_DELAY_3000);
                });
                localStorage.setItem('bookmark',"");          
    }

    addCategatoryData(cat: any): void {
        let categorydata: CategoryDataRecord = new CategoryDataRecord();
        categorydata.categoryId = cat;
        categorydata.subCategoryId = this.numberConstant.ZERO;
        this.reportservice.categoriesArray.push(categorydata);
    }

    addSubCateoryData(cat: any, subCat: any): void {
        let categorydata: CategoryDataRecord = new CategoryDataRecord();
        categorydata.categoryId = cat;
        categorydata.subCategoryId = subCat.id;
        this.reportservice.categoriesArray.push(categorydata);

    }

    setMaximum(config: any, maximum: any): void {
        maximum.selectedConfig = null;
        if (maximum.selected.length == this.numberConstant.ONE && maximum.selected[this.numberConstant.ZERO].selected == true) {
            maximum.selectedConfig = maximum.selected[this.numberConstant.ZERO];
            this.selectedRowMaximum = maximum;
        }
    }

    bulkDelete() {
        this.deleteMaximums(this.selectedRowMaximum.selected);
    }

    bulkApprove() {
        let maximumArr = [];
        for (let i: number = this.numberConstant.ZERO; i < this.selectedRowMaximum.selected.length; i++) {
            let approvals = this.selectedRowMaximum.selected[i].approvals
            for (let j: number = this.numberConstant.ZERO; j < approvals.length; j++) {
                let found = approvals[j].authorName.indexOf("@");
                let authorname = this.currentUser.email;
                if (found === this.numberConstant.MINUS_ONE) {
                    let arr = this.currentUser.email.split('@');
                    authorname = arr[this.numberConstant.ZERO];
                }
                if (approvals[j].authorName === authorname) {
                    maximumArr.push(this.selectedRowMaximum.selected[i]);
                    break;
                }
            }
        }
        if (maximumArr.length > this.numberConstant.ZERO) {
            this.approveMaximums(maximumArr);
        } else {
            this.alertService.warn(this.limitsconstant.userNotAssignedtoApproverList);
            window.setTimeout(() => this.alertService.clear(), this.numberConstant.ALERT_DELAY_3000);
            return;
        }
    }

    deleteMaximums(maximums: any) {
        maximums[this.numberConstant.ZERO].productId = this.reportservice.selectedprodID;
        maximums[this.numberConstant.ZERO].versionId = this.reportservice.selectedversionID;
        if (maximums[this.numberConstant.ZERO].subcategoryId === undefined) {
            maximums[this.numberConstant.ZERO].subcategoryId = this.numberConstant.ZERO;
        }
        if (maximums[this.numberConstant.ZERO].categoryId === undefined) {
            maximums[this.numberConstant.ZERO].categoryId = this.numberConstant.ZERO;
        }
        maximums[this.numberConstant.ZERO]["vmwareProductName"] = this.reportservice.selectedprodName;
        maximums[this.numberConstant.ZERO]["vmwareProductVersionName"] = this.reportservice.selectedverName;
        maximums[this.numberConstant.ZERO].updatedBy = this.currentUser.email;
        this.limitsService.bulkdeleteConfigurations(maximums)
            .subscribe(responseData => {
                if (responseData && responseData.status === "OK") {
                    this.alertService.success(responseData.message);
                    window.setTimeout(() => this.alertService.clear(), this.numberConstant.ALERT_DELAY_3000);
                    this.getdata(this.reportservice.selectedprodID, this.reportservice.selectedversionID);
                } else {
                    this.alertService.warn(this.limitsconstant.configDeleteFailureAlertLabel);
                    window.setTimeout(() => this.alertService.clear(), this.numberConstant.ALERT_DELAY_3000);
                }
            },
                err => {
                    console.log(err);
                    this.alertService.warn(this.limitsconstant.configDeleteFailureAlertLabel);
                    window.setTimeout(() => this.alertService.clear(), this.numberConstant.ALERT_DELAY_3000);
                });
    }

    approveMaximums(maximums: any) {
        maximums[this.numberConstant.ZERO].productId = this.reportservice.selectedprodID;
        maximums[this.numberConstant.ZERO].versionId = this.reportservice.selectedversionID;
        if (maximums[this.numberConstant.ZERO].subcategoryId === undefined) {
            maximums[this.numberConstant.ZERO].subcategoryId = this.numberConstant.ZERO;
        }
        if (maximums[this.numberConstant.ZERO].categoryId === undefined) {
            maximums[this.numberConstant.ZERO].categoryId = this.numberConstant.ZERO;
        }
        maximums[this.numberConstant.ZERO]["vmwareProductName"] = this.reportservice.selectedprodName;
        maximums[this.numberConstant.ZERO]["vmwareProductVersionName"] = this.reportservice.selectedverName;
        maximums[this.numberConstant.ZERO].updatedBy = this.currentUser.email;
        this.limitsService.bulkapproveConfigurations(maximums)
            .subscribe(responseData => {
                if (responseData && responseData.status === "OK") {
                    this.alertService.success(responseData.message);
                    window.setTimeout(() => this.alertService.clear(), this.numberConstant.ALERT_DELAY_3000);
                    this.getdata(this.reportservice.selectedprodID, this.reportservice.selectedversionID);
                } else {
                    this.alertService.warn(this.limitsconstant.configApproveFailureAlertLabel);
                    window.setTimeout(() => this.alertService.clear(), this.numberConstant.ALERT_DELAY_3000);
                }
            },
                err => {
                    console.log(err);
                    this.alertService.warn(this.limitsconstant.configApproveFailureAlertLabel);
                    window.setTimeout(() => this.alertService.clear(), this.numberConstant.ALERT_DELAY_3000);
                });
    }

    editCategory(maximum): void {
        this.categorymodal.open(maximum, this.reportservice.selectedprodName,
            this.reportservice.selectedverName);
        this.maximum_edited = maximum;
    }

    handleSaveCategory(category: MaximumCategory): void {
        let subcategory: any = null;
        category = this.reportservice.updateCategoriesInMenutree(this.maximum_edited, category, false);
        if (category.subcategories != undefined && category.subcategories.length > this.numberConstant.ZERO) {
            subcategory = category.subcategories[this.numberConstant.ZERO];
        }
        this.maximum_edited.primaryAuthor = category.primaryAuthor;
        this.maximum_edited.secondaryAuthor = category.secondaryAuthor;
        category.lastUpdate = new Date();
        category.updatedBy = this.currentUser.email;
        category.cmVmwProductId = this.reportservice.selectedprodID;
        category.cmVmwProdRelId = this.reportservice.selectedversionID;
        let catName = category.category;
        if (category.subCategory != undefined) {
            catName = catName + ":" + category.subCategory
        }
        this.limitsService.updateCategory(category)
            .subscribe(responseData => {
                if (responseData.status && responseData.status === "OK") {
                    this.reportservice.updateCategoriesInMenutree(this.maximum_edited, category, false);
                    this.alertService.success(catName + this.globals.categoryUpdateSuccesslabel)
                    this.maximum_edited.name = catName;
                    this.maximum_edited.comments = category.description;
                    this.getdata(this.reportservice.selectedprodID, this.reportservice.selectedversionID);
                    window.setTimeout(() => this.alertService.clear(), this.numberConstant.ALERT_DELAY_3000);
                }
            },
                err => {
                    console.log(err);
                    this.alertService.warn(catName + this.globals.categoryFailureUpdateLabel);
                    window.setTimeout(() => this.alertService.clear(), this.numberConstant.ALERT_DELAY_3000);
                });
    }

    deleteCategory(category: any): void {
        if (category != undefined && category.configs != undefined && category.configs.length > this.numberConstant.ZERO) {
            return;
        }
        let catName = category.category;
        if (category != null) {
            category.lastUpdate = new Date();
            category.updatedBy = this.currentUser.email;
            category.cmVmwProductId = this.reportservice.selectedprodID;
            category.cmVmwProdRelId = this.reportservice.selectedversionID;
            if (category != undefined) {
                if (category.subCategory != undefined) {
                    catName = catName + ":" + category.subCategory
                }
                this.limitsService.deleteCategory(category)
                    .subscribe(responseData => {
                        if (responseData.status && responseData.status === "OK") {
                            this.alertService.success(responseData.message);
                            this.maximums.splice(this.maximums.indexOf(category), this.numberConstant.ONE);
                            this.reportservice.updateCategoriesInMenutree(category, null, true);
                            window.setTimeout(() => this.alertService.clear(), this.numberConstant.ALERT_DELAY_3000);
                        }
                    },
                        err => {
                            console.log(err);
                            this.alertService.warn(catName + this.globals.categoryFailureDeleteLabel);
                            window.setTimeout(() => this.alertService.clear(), this.numberConstant.ALERT_DELAY_3000);
                        });
            }
        }
    }

    getAuthorsList(performauthor:ConfigMaxSetAttrAuthors , qeauthor:ConfigMaxSetAttrAuthors , prodauthor:ConfigMaxSetAttrAuthors ,
         devauthor:ConfigMaxSetAttrAuthors,id:number):any {
        let arr = [];
        if(performauthor != null) {
            if(id > this.numberConstant.ZERO)
            performauthor.configMaxSetAttrId = id;
        arr.push(performauthor);
        }
        if(qeauthor != null) {
            if(id > this.numberConstant.ZERO)
            qeauthor.configMaxSetAttrId = id;
        arr.push(qeauthor);
        }
        if(prodauthor != null) {
            if(id > this.numberConstant.ZERO)
            prodauthor.configMaxSetAttrId = id;
        arr.push(prodauthor);
        }
        if(devauthor != null) {
            if(id > this.numberConstant.ZERO)
            devauthor.configMaxSetAttrId = id;
        arr.push(devauthor);
        }
        return arr;
    }
}


// WEBPACK FOOTER //
// ./src/app/limits/limits.component.ts